export default __webpack_public_path__ + "static/media/flagRwanda.59b426b8.svg";